module.exports = {
	"ha": "vcha",
	"id": 1.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020",
					"2020",
					"2020"
				],
				"tickPositions": [
					0,
					4,
					8,
					12,
					16
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					6.158,
					6.011,
					6.321,
					6.185,
					6.88,
					6.824,
					6.737,
					6.63,
					7.413,
					6.942,
					6.47,
					6.233,
					6.617,
					6.809,
					6.716,
					6.781,
					5.865,
					3.73,
					5.206,
					{
						"y": 4.98,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 5,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					5.642,
					5.43,
					5.158,
					5.164,
					5.38,
					4.627,
					5.019,
					4.731,
					5.191,
					5.343,
					5.297,
					5.372,
					5.751,
					5.718,
					5.686,
					5.572,
					4.795,
					3.461,
					4.529,
					{
						"y": 4.415,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					34.293,
					34.28,
					32.928,
					31.323,
					34.026,
					33.765,
					33.146,
					31.457,
					34.153,
					35.159,
					35.105,
					33.99,
					36.595,
					36.833,
					38.459,
					36.793,
					34.294,
					23.061,
					32.199,
					{
						"y": 32.174,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_1_5.json
// module id = 287
// module chunks = 0